import { type ReactiveVar, useReactiveVar } from "@apollo/client";

import { makeFSVar } from "@shared/reactiveVar/makeFSVar";

/**
 * The Fullscript Category filter component is unable to distinguish if a newly
 * selected optimized mega menu option originated from outside or within the
 * component itself.
 *
 * This is important because if a selection happen from outside the component,
 * the Fullscript Category filter will need to show a different subset of the
 * taxonomy tree. If a selection happened from within, the component simply
 * shows the option as being checked.
 *
 * This reactive-var tracks when an optimized mega menu option is selected from
 * outside the Fullscript Category filter component.
 */
const INITIAL_STATE: string = "";

const selectedOptimizedMegaMenuItemVar: ReactiveVar<string> = makeFSVar(
  INITIAL_STATE,
  "useSelectedOptimizedMegaMenuItemVar"
);

const resetSelectedOptimizedMegaMenuItem = () => {
  selectedOptimizedMegaMenuItemVar(INITIAL_STATE);
};

const setSelectedOptimizedMegaMenuItem = (selectedOptimizedMegaMenuItem: string) => {
  selectedOptimizedMegaMenuItemVar(selectedOptimizedMegaMenuItem);
};

const useSelectedOptimizedMegaMenuItem = (): string => {
  return useReactiveVar(selectedOptimizedMegaMenuItemVar);
};

export {
  resetSelectedOptimizedMegaMenuItem,
  setSelectedOptimizedMegaMenuItem,
  useSelectedOptimizedMegaMenuItem,
};
